module.exports = __webpack_public_path__ + "img/icons_Prancheta 1-242.9aa1d1ca.svg";